import { MutationTree } from 'vuex'
import { IDoctorState } from '@/store/doctor'
import { Types, Store, Current, Filter } from '@/store/doctor/types'

const mutations: MutationTree<IDoctorState> = {
  [Types.store]: (state, action: Store) => {
    state.response = action.payload
  },
  [Types.current]: (state, action: Current) => {
    state.current = action.payload
  },
  [Types.filter]: (state, action: Filter) => {
    state.filter = action.payload
  }
}

export default mutations
